import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

export type ToolbarComposition = 'wrapper' | 'toolbarGroup' | 'option'

const createToolbarVariant = createStyles<ToolbarComposition>

export const ToolbarStyles = {
  default: createToolbarVariant(theme => ({
    wrapper: {
      ...theme.spacing.padding(2),
      ...theme.spacing.gap(2),
      ...theme.presets.flex,
      ...theme.presets.justifyStart,
      ...theme.presets.alignCenter,
      flexWrap: 'wrap',
      borderTopLeftRadius: theme.radius.regular,
      borderTopRightRadius: theme.radius.regular,
      ...theme.border({
        color: theme.baseColors.neutralSolid500,
        width: theme.stroke.regular,
      }),
      ...theme.presets.relative,
    },
    toolbarGroup: {
      backgroundColor: theme.baseColors.neutralSolid500,
      borderRadius: theme.radius.regular,
      overflow: 'hidden',
    },
    option: {
      width: '100%',
      height: '100%',
      ...theme.spacing.padding(1),
      background: theme.baseColors.neutralSolid300,
      ...theme.border({
        color: theme.baseColors.neutralSolid200,
        width: theme.stroke.regular,
        directions: ['left', 'right'],
      }),
    },
    'option:active': {
      background: theme.baseColors.primarySolid100,
    },
    'option:disabled': {},
  })),
}

StyleRegistry.registerVariants('ToolBar', ToolbarStyles)
